/**
 * React.memo comparator that skips re-rendering when only callback props changed identity.
 * Only use it where every callback the parent passes reads fresh state through functional
 * setState or refs, so an older copy of the function still does the right thing.
 */
export function sameDataProps<P extends object>(prev: Readonly<P>, next: Readonly<P>): boolean {
  const a = prev as Record<string, unknown>;
  const b = next as Record<string, unknown>;
  const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
  for (const key of keys) {
    if (typeof a[key] === 'function' && typeof b[key] === 'function') continue;
    if (!Object.is(a[key], b[key])) return false;
  }
  return true;
}
